import { IDataTableOptionalProps } from "../../../DataTable/common/defaults";
import {
  FormElementConfig,
  IFormElementConfig
} from "../../../DualValueFormElement/assets/BusinessObjects";
import { eFormElementType } from "../../../../services/Enums/shared";
import Moment from "moment";
import { extendMoment } from "moment-range";
const moment = extendMoment(Moment);

export enum LocationWorkflowStepName {
  SpotMapping = "SpotMapping",
  Review = "LocationReview"
}

export const locationQueueColumns = [
  {
    title: "Edit",
    data: "workFlowItemStepId"
  },
  {
    title: "Crash Key",
    data: "originalCrashKey"
  },
  {
    title: "Status",
    data: "status"
  },
  {
    title: "County",
    data: "county"
  },
  {
    title: "City",
    data: "city"
  },
  {
    title: "Route Id",
    data: "routeId"
  },
  {
    title: "Reference Post",
    data: "referencePost"
  },
  {
    title: "Street Name",
    data: "primaryRoadway"
  },
  {
    title: "Crash Date",
    mData: function (data, type, dataToSet) {
      return moment(data.crashDate).format("MM/DD/YYYY");
    }
  },
  {
    title: "Workflow Status",
    mData: function (data, type, dataToSet) {
      return data.status != null ? data.status : "Status Indeterminable";
    },
    className: "workflowStepStatus"
  },
  {
    title: "Priority",
    data: "keywords.priorityName"
  },
  {
    title: "hidden",
    data: "keywords.priorityNumber"
  }
];

export const locationQueueOptions: IDataTableOptionalProps = {
  info: true,
  showSelectInfo: false,
  lengthChange: false,
  select: false,
  dom: "tipB",
  orderFixed: {
    pre: [11, "asc"]
  },
  autoWidth: false
};

export const locationRecordConfigs: IFormElementConfig[] = [
  //new FormElementConfig("Crash Id",false,"crashId",eFormElementType.Textbox),
  new FormElementConfig(
    "Street Name",
    true,
    "streetName",
    eFormElementType.Textbox,
    ["StreetHighwayNo"]
  ),
  new FormElementConfig(
    "Route Number 1",
    true,
    "routeNumber",
    eFormElementType.Textbox,
    ["HighwayNo"],
    null,
    null,
    null,
    false
  ),
  new FormElementConfig(
    "Reference Post",
    true,
    "referencePost",
    eFormElementType.Textbox,
    ["RefPost"],
    null,
    null,
    null,
    false
  ),
  new FormElementConfig(
    "County",
    true,
    "countyName",
    eFormElementType.Dropdown,
    ["County"],
    "County",
    null,
    null,
    null,
    null,
    null,
    null,
    true
  ),
  new FormElementConfig(
    "City",
    true,
    "cityName",
    eFormElementType.Dropdown,
    ["City"],
    "City",
    null,
    null,
    null,
    null,
    null,
    null,
    false
  ),
  new FormElementConfig(
    "Ownership",
    true,
    "ownership",
    eFormElementType.Dropdown,
    ["PrivatePropertyInd"],
    "Ownership",
    null,
    null,
    null,
    null,
    null,
    null,
    true
  ),
  new FormElementConfig(
    "Trafficway Characteristics",
    true,
    "trafficwayCharacteristics",
    eFormElementType.Dropdown,
    ["TrafficwayChars"],
    "TrafficwayCharacteristics",
    null,
    null,
    null,
    null,
    null,
    null,
    true
  ),
  new FormElementConfig(
    "Location Description",
    true,
    "locationLine",
    eFormElementType.TextArea,
    ["LocationDescription"],
    null,
    null,
    null,
    false,
    true,
    null,
    2
  ),
  new FormElementConfig(
    "Within Interchange Area",
    true,
    "withinInterchangeArea",
    eFormElementType.Dropdown,
    ["WithinInterchangeArea"],
    "YesNoUnknown",
    null,
    null,
    null,
    null,
    null,
    null,
    true
  ),
  new FormElementConfig(
    "Specific Junction Location",
    true,
    "specificJunction",
    eFormElementType.Dropdown,
    ["SpecificJunctionLocation"],
    "FHESpecificLocation",
    null,
    null,
    null,
    null,
    null,
    null,
    true
  ), // New
  new FormElementConfig(
    "Railway Crossing Id",
    true,
    "railwayCrossingId",
    eFormElementType.Textbox,
    ["RailwayCrossingId"],
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    true
  ),
  new FormElementConfig(
    "First Harmful Event",
    true,
    "firstHarmfulEvent",
    eFormElementType.Dropdown,
    ["FirstHarmEvent"],
    "MostHarmfulEvent", //NonCollisionHarmfulEvent #3943
    null,
    null,
    null,
    null,
    null,
    null,
    true
  ),
  new FormElementConfig(
    "Location of First Harmful Event",
    true,
    "locationOfFirstHarmfulEvent",
    eFormElementType.Dropdown,
    ["FirstHarmEventLocation"],
    "LocationOfFirstHarmfulEvent",
    null,
    null,
    null,
    null,
    null,
    null,
    true
  ),
  new FormElementConfig(
    "Manner of Crash",
    true,
    "mannerOfCrash",
    eFormElementType.Dropdown,
    ["MannerOfCrashCollisionImpact"],
    "FHEMannerOfCrash",
    null,
    null,
    null,
    null,
    null,
    null,
    true
  )
  //new FormElementConfig('Name of Intersecting Roadway',true,'nameOfIntersectingRoadway',eFormElementType.Textbox,null,null,null,false,false), // New
  //new FormElementConfig("Crash Classification",true,"crashClassification",eFormElementType.Dropdown,"CrashClassificationType"), // New
  //new FormElementConfig("Within Interchange Area",true,"withinInterchangeArea",eFormElementType.Dropdown,"YesNoUnknown"),
  //new FormElementConfig("Number Of Approaches",true,"numberOfApproaches",eFormElementType.Dropdown,"NumberOfApproachTypes"),
  //new FormElementConfig("Overall Intersection Geometry",true,"overallIntersectionGeometry",eFormElementType.Dropdown,"OverallIntersectionGeometry"),
  //new FormElementConfig("Overall Traffic Control Device",true,"overallTrafficControlDevice",eFormElementType.Dropdown,"OverallTrafficControlDevice"),
  //new FormElementConfig("Direction Of Travel Before Crash",true,"directionOfTravelBeforeCrash",eFormElementType.Dropdown,"VehicleMovementDirection"),
  //new FormElementConfig("Maneuver",true,"maneuver",eFormElementType.Dropdown,"VehicleManeuver")
];

interface IInternalCrashDataCorrection {
  crashId: number;
  streetName?: string;
  nameOfIntersectingRoadway?: string;
  ownership?: string;
  crashClassification?: string;
  countyName?: string;
  cityName?: string;
  firstHarmfulEvent?: string;
  locationOfFirstHarmfulEvent?: string;
  mannerOfCrash?: string;
  withinInterchangeArea?: string;
  numberOfApproaches?: string;
  overallIntersectionGeometry?: string;
  overallTrafficControlDevice?: string;
  railwayCrossingId?: string;
  directionOfTravelBeforeCrash?: string;
  maneuver?: string;
  lastModifiedByUserId?: number;
}

export class InternalCrashDataCorrection
  implements IInternalCrashDataCorrection
{
  constructor(
    public crashId: number,
    public streetName?: string,
    public nameOfIntersectingRoadway?: string,
    public ownership?: string,
    public crashClassification?: string,
    public countyName?: string,
    public cityName?: string,
    public firstHarmfulEvent?: string,
    public locationOfFirstHarmfulEvent?: string,
    public mannerOfCrash?: string,
    public withinInterchangeArea?: string,
    public numberOfApproaches?: string,
    public overallIntersectionGeometry?: string,
    public overallTrafficControlDevice?: string,
    public railwayCrossingId?: string,
    public directionOfTravelBeforeCrash?: string,
    public maneuver?: string,
    public lastModifiedByUserId?: number,
    public spdCheckbox?: boolean
  ) {}
}
